import React from 'react';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

const LabelListEmptyPlaceholder = (): React.ReactElement => {
    const translate = useTranslator('popup', 'labels.menu');
    const imageUri = require('../images/labels-placeholder.png');

    return (
        <div className="LabelListEmptyPlaceholder justify-center py-5xl px-4xl">
            <div className="flex flex-col items-center gap-3xl">
                <img alt="" aria-hidden="true" src={imageUri} draggable={false} className="block max-w-[180px]" />
                <span className="text-md font-medium text-tertiary text-center ">
                    {translate('emptyListPlaceholder')}
                </span>
            </div>
        </div>
    );
};

export default LabelListEmptyPlaceholder;
